import { action, set } from '@ember/object';
import { service } from '@ember/service';
import type Store from '@ember-data/store';
import Component from '@glimmer/component';
import { getUnixTime } from 'date-fns';
import type TakeoverModel from 'garaje/models/takeover';
import type FlashMessagesService from 'garaje/services/flash-messages';
import type MetricsService from 'garaje/services/metrics';
import type StateService from 'garaje/services/state';

interface BannerTakeoverArgs {
  takeovers: TakeoverModel[];
  announcementId?: string;
}

export default class Takeover extends Component<BannerTakeoverArgs> {
  @service declare store: Store;
  @service declare flashMessages: FlashMessagesService;
  @service declare metrics: MetricsService;
  @service declare state: StateService;

  @action
  async endTakeover(takeover: TakeoverModel): Promise<void> {
    this.metrics.trackEvent('WEB_END_TAKEOVER_BUTTON_TAPPED', {
      company_id: this.state.currentCompany?.id,
      location_id: this.state.currentLocation?.id,
      announcement_id: this.args.announcementId,
    });
    try {
      const timestamp = getUnixTime(new Date());
      set(takeover, 'endAt', timestamp);
      await takeover.save();
      this.flashMessages.showAndHideFlash('success', 'Takeover ended');
    } catch (_error) {
      this.flashMessages.showAndHideFlash('error', 'Something went wrong, please try again. error');
    }
  }
}
